'use strict'

import Axios from 'axios'
import UtilFormatter from './../utils/UtilFormatter'
import configuration from '../../configuration';
import PersonService from './PersonService';

const url = configuration.apiHost + "companies";

export default class CompanyService {

  static async getAll() {
    try {
      let companies = await Axios.get(`${url}`);
      return companies.data;
    } catch (error) {
      throw error.response.data;
    }
  } // getAll()

  static async getCompaniesForSpecificData(/* Array de parametros? */) {
    try {
      let companySaved = await Axios.get(`${url}/find/ _id socialName fantasyName address`);
      return companySaved.data;
    } catch (error) { 
      throw error.response.data;
    }
  } //getCompaniesForSpecificData(data)

  static async findWithoutDocuments(/* Array de parametros? */) {
    try {
      let companySaved = await Axios.get(`${url}/noDocument`);
      return companySaved.data;
    } catch (error) { 
      throw error.response.data;
    }
  } //getCompaniesForSpecificData(data)

  

  static async save(company) {
    try {
      let companySaved = await Axios.post(`${url}`, company);
      return companySaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(company) {
    try {
      let companyUpdated = await Axios.put(`${url}`, company);
      return companyUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(company) {
    try {
      await Axios.delete(`${url}`, {
        data: company
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()
} // class



// WEBPACK FOOTER //
// ./src/service/CompanyService.js